// export const userClinicSettings = [
//   { label: "Clinic Name", name: "name", type: "text" },
//   { label: "Phone Number", name: "phone_number", type: "text" },
//   { label: "Schedule", name: "schedule", type: "text" },
//   { label: "Time", name: "time", type: "text" },
//   { label: "Address", name: "address", type: "textarea" },
// ];

// settings.js
export const userClinicSettings = [
  {
    label: "Clinic Name",
    name: "name",
    type: "text",
    placeholder: "Enter clinic name",
  },
  {
    label: "Phone Number",
    name: "phone_number",
    type: "text",
    placeholder: "e.g. 09171234567",
  },
  {
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "e.g. clinic@example.com",
  },
  {
    label: "Website",
    name: "website",
    type: "text",
    placeholder: "e.g. www.clinic.com",
  },
  {
    label: "Schedule (Days)",
    name: "schedule",
    type: "text",
    placeholder: "e.g. Monday - Saturday",
  },
  {
    label: "Clinic Hours",
    name: "time",
    type: "text",
    placeholder: "e.g. 9:00 AM - 5:00 PM",
  },
  {
    label: "Address",
    name: "address",
    type: "textarea",
    placeholder: "Enter full clinic address",
  },
];
